import { useEffect, useState} from 'react';
import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Wave from '../components/Wave';
import phone from '../assets/phone.png';
import ButtonStore from '../components/ButtonStore'
import Tasks from '../assets/Tasks.png';
import Feed from '../assets/Feed.png';
import Friends from '../assets/Friends.png';
import Communautes from '../assets/Communautes.png';
import BasketballIcons from '../assets/icons/Basketball.png';
import ClappingHandsIcon from '../assets/icons/ClappingHands.png';
import CryingFaceIcon from '../assets/icons/CryingFace.png';
import FaceWithTearsOfJoyIcon from '../assets/icons/FaceWithTearsOfJoy.png';
import HouseIcon from '../assets/icons/House.png';
import HushedFaceIcon from '../assets/icons/HushedFace.png';
import RedHeartIcon from '../assets/icons/RedHeart.png';
import RocketIcon from '../assets/icons/Rocket.png';
import SmilingFaceWithHeartsIcon from '../assets/icons/SmilingFaceWithHearts.png';
import ThumbsUpIcon from '../assets/icons/ThumbsUp.png';
import VideoGameIcon from '../assets/icons/VideoGame.png';
import { themeColors } from '../theme/colors';

function LandingPage() { 

  React.useEffect(() => {
    var _mtm = (window._mtm = window._mtm || []);
    _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
    var d = document,
    g = d.createElement("script"),
    s = d.getElementsByTagName("script")[0];
    g.async = true;
    g.src = "https://analytics.preprod.qalmo.fr/js/container_LnaaM1aY.js";
    s.parentNode.insertBefore(g, s);
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const target = document.querySelector(location.hash);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location]);

  const images = [Tasks, Feed, Friends, Communautes];

  const titles = [
    "Crée tes tâches",
    "Vois celles de tes amis",
    "Partage avec tes amis",
    "Rejoins des communautés"
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [lastInteractionTime, setLastInteractionTime] = useState(Date.now());
  const [isInWordPage, setIsInWordPage] = useState(false);

  useEffect(() => {
    const wordPage = document.getElementById('WordPage');
    const footer = document.getElementById('Footer');
    const titles = document.getElementById('titles');
    if (!wordPage || !footer || !titles) return;

    const handleScroll = () => {
      const headerElement = document.querySelector('div.fixed');
      const headerHeight = headerElement ? headerElement.offsetHeight : 64;

      const wordPageRect = wordPage.getBoundingClientRect();
      const footerPageRect = footer.getBoundingClientRect();
      const headerBottom = headerHeight;

      const isHeaderInWordPage =
        wordPageRect.top <= 0 && footerPageRect.bottom >= headerBottom;

      let isHeaderInTitles = false;

      if (window.innerWidth <= 768) {
        const titlesRect = titles.getBoundingClientRect();
        isHeaderInTitles = titlesRect.top <= headerBottom && titlesRect.bottom >= 0;
      }

      setIsInWordPage(isHeaderInWordPage || isHeaderInTitles);
    };


    handleScroll();

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  useEffect(() => {
  const interval = setInterval(() => {
    if (Date.now() - lastInteractionTime >= 7000) {
      setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
      setLastInteractionTime(Date.now());
    }
  }, 1000);

  return () => clearInterval(interval);
}, [lastInteractionTime, images.length]);

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    setLastInteractionTime(Date.now());
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    setLastInteractionTime(Date.now());
  };

  return (
    <div className="flex flex-col font-fraunces overflow-x-hidden">
      <div className="bg-gradient w-screen min-h-screen overflow-hidden">
        <Header isInWordPage={isInWordPage} />
        <div className='md:pt-28 pt-24'>
          <div className="lg:-mt-6 flex flex-col lg:flex-row items-center space-y-12 lg:space-y-0 p-6 lg:px-16">
            <div className="lg:ml-16 flex-1 lg:flex-none lg:w-1/2 flex flex-col items-center lg:-mt-20 justify-center text-center space-y-16">
              <h1 className="text-white text-[31px] md:text-[55px] lg:text-[75px] font-bold leading-[1.25]">
                Partage ton quotidien, <br />
                inspire ton entourage.
              </h1>
              <div className="hidden lg:flex flex-row justify-center space-x-5">
                <ButtonStore store="ios" />
                <ButtonStore store="android" />
              </div>
            </div>
            <div className="flex w-full items-center justify-center">
              <img className="w-[350px] md:w-[425px] lg:w-[500px]" src={phone} alt="phone" loading="lazy"/>
            </div>
          </div>
          <div id="a-quoi-ca-sert" className="lg:mt-0 mt-12">
            <Wave type="up"/>
            <div className="h-[750px] bg-white flex items-center justify-center text-center lg:-mt-2 -mt-1">
              <div className="flex flex-col items-center space-y-24 lg:space-y-16">
                <h1 className="text-[25px] md:text-4xl lg:text-6xl font-bold">
                  Sois hypé avec tes potes, <br/>
                  complétez vos objectifs, <br/>
                  inspirez-vous les uns les autres. <br/>
                </h1>
                <div className="flex lg:space-x-5 space-x-4">
                  <ButtonStore store="ios" />
                  <ButtonStore store="android" />
                </div>
              </div>
            </div>
            <Wave type="down"/>
          </div>
          <div className="h-[1250px] flex flex-col items-center justify-center space-y-6">
            <div className="relative w-full max-w-md mx-auto">
              <div id="fonctionnalites" className={`bg-[${themeColors.qalmoBlue}] py-12 sm:py-8 lg:py-12 rounded-lg mb-4 transform rotate-[-5deg] max-w-[375px] sm:max-w-md lg:max-w-2xl mx-auto`}>
                <h2 id="titles" className="text-white text-center md:text-3xl text-2xl font-bold">
                  {titles[currentIndex]}
                </h2>
              </div>
              <img src={images[currentIndex]} alt={titles[currentIndex]} className="w-full h-auto rounded-xl" />
              <button
                onClick={goToPrevious}
                className="absolute left-2 md:-left-20 lg:-left-40 top-1/2 transform -translate-y-1/2 
                          bg-white w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 
                          flex items-center justify-center rounded-full shadow 
                          text-lg md:text-2xl lg:text-3xl mt-10 md:mt-0"
                aria-label="Previous image"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 text-black" fill="none" viewBox="0 0 24 24" 
                     stroke="currentColor" strokeWidth={2} >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <button
                onClick={goToNext}
                className="absolute right-2 md:-right-20 lg:-right-40 top-1/2 transform -translate-y-1/2 
                          bg-white w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 
                          flex items-center justify-center rounded-full shadow 
                          text-lg md:text-2xl lg:text-3xl mt-10 md:mt-0"
                aria-label="Next image"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 text-black" fill="none" viewBox="0 0 24 24" 
                     stroke="currentColor" strokeWidth={2} >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
          
          <div id="WordPage">
            <Wave type="up" color={`${themeColors.qalmoBlue}`}/>
              <div className="lg:h-[1250px] md:h-[1100px] h-[750px] relative bg-qalmo py-12 px-6 overflow-hidden flex flex-col items-center text-white -mt-1">
                <div className="interests interests--icon relative w-full h-full">
                  <img loading="lazy" src={BasketballIcons} alt="Basketball" className="absolute lg:top-[-10%] lg:left-[15%] top-[-10%] left-[10%]" />
                  <img loading="lazy" src={ClappingHandsIcon} alt="Clapping Hands" className="absolute lg:top-[30%] lg:left-[23%] top-[35%] left-[20%]" />
                  <img loading="lazy" src={CryingFaceIcon} alt="Crying Face" className="absolute lg:top-[35%] lg:left-[70%] top-[35%] left-[75%]" />
                  <img loading="lazy" src={FaceWithTearsOfJoyIcon} alt="Face with Tears of Joy" className="absolute lg:top-[60%] lg:left-[10%] top-[60%] left-[0%]" />
                  <img loading="lazy" src={HouseIcon} alt="House" className="absolute lg:top-[0%] lg:left-[80%] top-[-20%] left-[85%]" />
                  <img loading="lazy" src={HushedFaceIcon} alt="Hushed Face" className="absolute lg:top-[5%] lg:left-[35%] top-[95%] left-[35%]" />
                  <img loading="lazy" src={RedHeartIcon} alt="Red Heart" className="absolute lg:top-[70%] lg:left-[60%] top-[110%] left-[60%]" />
                  <img loading="lazy" src={RocketIcon} alt="Rocket" className="absolute lg:top-[80%] lg:left-[30%] top-[105%] left-[10%]" />
                  <img loading="lazy" src={SmilingFaceWithHeartsIcon} alt="Smiling Face With Hearts" className="absolute lg:top-[-5%] lg:left-[55%] top-[0%] left-[50%]" />
                  <img loading="lazy" src={ThumbsUpIcon} alt="Thumbs Up" className="absolute lg:top-[100%] lg:left-[75%] top-[70%] left-[85%]" />
                  <img loading="lazy" src={VideoGameIcon} alt="Video Game" className="absolute lg:top-[40%] lg:left-[45%] top-[50%] left-[50%]" />
                </div>
                <div className="flex flex-col items-center justify-center text-center space-y-10 z-10 mt-[110px]">
                  <h2 className="text-3xl lg:text-7xl font-bold">
                    Organise ta vie
                  </h2>
                  <div className="flex space-x-4 justify-center">
                    <ButtonStore store="ios" />
                    <ButtonStore store="android" />
                  </div>
                </div>
                <div className="absolute inset-0 z-0">
                  <span style={{ color: themeColors.purpleMedium }} className={`absolute lg:text-5xl md:text-4xl text-xl font-semibold rotate-[-11deg] lg:top-[60%] lg:left-[10%] top-[67%] left-[10%]`}>Bien-être</span>
                  <span style={{ color: themeColors.blue }} className={`absolute lg:text-3xl md:text-2xl text-xl font-semibold rotate-[-10deg] lg:top-[86%] lg:left-[80%] top-[90%] left-[80%]`}>Loisir</span>
                  <span style={{ color: themeColors.pink }} className={`absolute lg:text-3xl md:text-2xl text-xl font-semibold rotate-[13deg] lg:top-[91%] lg:left-[55%] top-[95%] left-[65%]`}>Sport</span>
                  <span style={{ color: themeColors.purpleLight }} className={`absolute lg:text-3xl md:text-2xl text-xl font-semibold rotate-[14deg] lg:top-[90%] lg:left-[10%] top-[94%] left-[10%]`}>Foyer</span>
                  <span style={{ color: themeColors.yellow }} className={`absolute lg:text-5xl md:text-4xl text-xl font-semibold rotate-[7deg] lg:top-[63%] lg:left-[48%] top-[75%] left-[56%]`}>Communautés</span>
                  <span style={{ color: themeColors.green }} className={`absolute lg:text-6xl md:text-5xl text-3xl font-semibold rotate-[12deg] lg:top-[60%] lg:left-[72%] top-[69%] left-[65%]`}>Objectifs</span>
                  <span style={{ color: themeColors.green }} className={`absolute lg:text-5xl md:text-4xl text-xl font-semibold lg:rotate-[8deg] rotate-[-8deg] lg:top-[77%] lg:left-[12%] top-[94%] left-[32%]`}>Productivité</span>
                  <span style={{ color: themeColors.yellow }} className={`absolute lg:text-7xl md:text-6xl text-4xl font-semibold rotate-[-7deg] lg:top-[90%] lg:left-[32%] top-[85%] left-[5%]`}>Potes</span>
                  <span style={{ color: themeColors.lavender }} className={`absolute lg:text-4xl md:text-3xl text-xl font-semibold rotate-[-8deg] lg:top-[68%] lg:left-[28%] top-[71%] left-[28%]`}>Travail</span>
                  <span style={{ color: themeColors.lavender }} className={`absolute lg:text-6xl md:text-5xl text-3xl font-semibold rotate-[-14deg] lg:top-[80%] lg:left-[60%] top-[84%] left-[60%]`}>Partage</span>
                  <span style={{ color: themeColors.blue }} className={`absolute lg:text-7xl md:text-6xl text-4xl font-semibold lg:top-[75%] lg:left-[43%] top-[79%] left-[33%]`}>Tâches</span>
                </div>
              </div>
          </div>
          <div id="Footer" style={{ backgroundColor: '#000B23' }} className='lg:-mt-1 -mt-1 '>
            <div className="pt-24 w-full overflow-hidden relative -mb-1 ">
              <svg
                className="w-full lg:h-16 h-8 md:scale-x-100 scale-x-125"
                viewBox="0 0 100 100"
                preserveAspectRatio="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M-2,100 Q50,-100 102,100 Z"
                  fill={themeColors.purpleMedium}
                />
              </svg>
            </div>
            <Footer />
          </div>    
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
